export const setGetDocumentQueryParams = (
  options: {
    pageIndex: number
    pageSize: number
  },
  search: string | null,
  sorting: { id: string; desc: boolean }[]
): URLSearchParams => {
  const { pageIndex, pageSize } = options
  const params = new URLSearchParams()
  if (pageSize) params.append('limit', pageSize.toString())
  if (pageIndex) params.append('offset', (pageIndex * pageSize).toString())
  if (search) {
    params.append('search', search)
  }
  if (sorting && sorting.length > 0) {
    const sort = sorting[0]
    params.append('sort', sort.id)
    params.append('order', sort.desc ? 'desc' : 'asc')
  }
  return params
}
